"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPlacement = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Elevation_1 = require("../../common/enums/Elevation");
var ComponentTitleStyle_1 = require("../typography/ComponentTitleStyle");
var ComponentUtils_1 = require("../common/ComponentUtils");
var DeprecationUtils_1 = require("../../utils/DeprecationUtils");
var ChildrenUtils_1 = require("../../common/ChildrenUtils");
var CardBadge_1 = __importStar(require("./CardBadge"));
var badge_1 = require("../badge");
var IconPlacement;
(function (IconPlacement) {
    IconPlacement["FEATURED"] = "featured";
    IconPlacement["SECONDARY"] = "secondary";
})(IconPlacement = exports.IconPlacement || (exports.IconPlacement = {}));
var badgeType = (react_1.default.createElement(CardBadge_1.default, { text: 'foo' })).type;
var CardHeader = function (props) {
    var badgePosition = props.badgePosition, children = props.children, classes = props.classes, elevation = props.elevation, graphicNode = props.graphicNode, icon = props.icon, iconPlacement = props.iconPlacement, note = props.note, separatorBottom = props.separatorBottom, subtitle = props.subtitle, subtitleClasses = props.subtitleClasses, subtitleVertical = props.subtitleVertical, titleStyle = props.titleStyle, otherProps = __rest(props, ["badgePosition", "children", "classes", "elevation", "graphicNode", "icon", "iconPlacement", "note", "separatorBottom", "subtitle", "subtitleClasses", "subtitleVertical", "titleStyle"]);
    if (note) {
        DeprecationUtils_1.logDeprecatedPropValue({
            propName: 'note',
            component: 'CardHeader',
            seeMsg: 'Please use the `subtitle` prop instead of the `note` prop.',
            versionStart: '1.1.1',
            versionEnd: '2.0.0'
        });
    }
    // TODO: Move badge logic into single function once we have basic left rendering
    var badges = getBadges(badgePosition, children);
    return (react_1.default.createElement("div", __assign({}, otherProps, { className: getClassNames(classes, elevation, separatorBottom, iconPlacement) }),
        !badges && graphicNode,
        icon && iconPlacement === IconPlacement.SECONDARY &&
            getSecondaryIconPlacement(children, icon, subtitle || note, subtitleClasses, subtitleVertical, titleStyle, badgePosition, graphicNode, badges),
        icon && iconPlacement === IconPlacement.FEATURED && badgePosition !== CardBadge_1.BadgePositions.RIGHT &&
            ComponentUtils_1.addCSSClassesToComponent(icon, 'fds-card-header-icon-featured'),
        (!icon || icon && iconPlacement === IconPlacement.FEATURED) &&
            getHeadline(children, subtitle || note, subtitleClasses, subtitleVertical, titleStyle, badgePosition, graphicNode, badges, icon)));
};
CardHeader.defaultProps = {
    elevation: Elevation_1.DEFAULT_ELEVATION,
    titleStyle: ComponentTitleStyle_1.DEFAULT_COMPONENT_TITLE_STYLE,
    iconPlacement: IconPlacement.FEATURED,
    badgePosition: CardBadge_1.BadgePositions.LEFT
};
var getBadges = function (badgePosition, children) {
    var badges = ChildrenUtils_1.filterChildrenIn(children, badgeType);
    badges && badges.map(function (child) { return react_1.default.cloneElement(child, { badgePosition: badgePosition }); });
    if (Array.isArray(badges) && badges.length === 0) {
        return null;
    }
    var badgelessChildren = ChildrenUtils_1.filterChildrenOut(children, badgeType);
    return (react_1.default.createElement("div", { className: classnames_1.default('fds-badge-container', {
            'fds-card-badge-right': badgePosition === CardBadge_1.BadgePositions.RIGHT,
            'fds-card-basic-badge-left': badgePosition === CardBadge_1.BadgePositions.LEFT,
            'fds-card-basic-badge-left-no-title': Array.isArray(badgelessChildren) && badgelessChildren.length === 0
        }) },
        react_1.default.createElement(badge_1.BadgeGroup, null, badges)));
};
// TODO: Refactor after last vertical card to strip out nesting logic
var getBadgeOrientationWrapper = function (graphic, badges, badgePosition, icon, header) {
    if (header === void 0) { header = null; }
    if (badges && graphic) {
        return (badgePosition === CardBadge_1.BadgePositions.RIGHT) ? (react_1.default.createElement("div", { className: 'fds-card-header-graphic-badge-wrapper' },
            graphic,
            badges)) : (react_1.default.createElement(react_1.default.Fragment, null,
            graphic,
            badges,
            header));
    }
    else if (badgePosition === CardBadge_1.BadgePositions.RIGHT && !graphic && icon) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classnames_1.default('fds-card-header-badge-wrapper-right', 'fds-badge-icon-right') },
                icon,
                badges),
            header));
    }
    else if (badges && badgePosition === CardBadge_1.BadgePositions.RIGHT && !graphic) {
        return (react_1.default.createElement("div", { className: classnames_1.default('fds-card-header-badge-wrapper-right') },
            header,
            badges));
    }
    else if (badges && badgePosition === CardBadge_1.BadgePositions.LEFT) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            badges,
            header));
    }
    return header;
};
var getClassNames = function (classes, elevation, separatorBottom, iconPlacement) {
    var _a;
    return classnames_1.default('fds-card-header', 'fds-cell', (_a = {
            'fds-card-separator-bottom': separatorBottom
        },
        _a["elevation-" + elevation] = elevation && elevation !== Elevation_1.DEFAULT_ELEVATION,
        _a['fds-secondary-icon-placement-alignment'] = iconPlacement === IconPlacement.SECONDARY,
        _a), classes);
};
var getHeadline = function (children, subtitle, subtitleClasses, subtitleVertical, titleStyle, badgePosition, graphic, badges, icon) {
    var _a;
    var headerClasses = classnames_1.default('fds-card-header-body', {
        vertical: subtitle && subtitleVertical
    });
    var titleClasses = classnames_1.default('fds-card-header-title', (_a = {},
        _a["fds-title-type-" + titleStyle] = titleStyle && titleStyle !== ComponentTitleStyle_1.DEFAULT_COMPONENT_TITLE_STYLE,
        _a));
    var badgelessChildren = ChildrenUtils_1.filterChildrenOut(children, badgeType);
    var header = (react_1.default.createElement("header", { className: headerClasses },
        react_1.default.createElement("h3", { className: titleClasses }, badgelessChildren),
        subtitle && (react_1.default.createElement("p", { className: classnames_1.default('fds-card-header-subtitle', subtitleClasses) }, subtitle))));
    if (Array.isArray(badgelessChildren) && badgelessChildren.length === 0) {
        return getBadgeOrientationWrapper(graphic, badges, badgePosition, icon);
    }
    return getBadgeOrientationWrapper(graphic, badges, badgePosition, icon, header);
};
var getSecondaryIconPlacement = function (children, icon, subtitle, subtitleClasses, subtitleVertical, titleStyle, badgePosition, graphicNode, badges) {
    return (react_1.default.createElement("div", { className: "fds-grid" },
        react_1.default.createElement("div", { className: "fds-cell all-cell-fill" }, getHeadline(children, subtitle, subtitleClasses, subtitleVertical, titleStyle, badgePosition, graphicNode, badges, icon)),
        react_1.default.createElement("div", { className: "fds-cell all-cell-shrink" }, ComponentUtils_1.addCSSClassesToComponent(icon, 'fds-card-header-icon-secondary'))));
};
exports.default = CardHeader;
